import React from 'react';

const TuitionPage = () => (
    <div className='content'>

        <table className='schedule'>
            <tbody>
            <tr>
                <th colSpan='2'>
                    <p>2021-2022 School Year</p>
                    <p>9:30am to 1:30pm Monday - Friday</p>
                    <p>Choose 2, 3, 4 or 5 days per week</p>
                </th>
            </tr>
            <tr>
                <td className='time'>2 days/week
                </td>
                <td className='description'>$385.00/month
                </td>
            </tr>
            <tr>
                <td className='time'>3 days/week
                </td>
                <td className='description'>$505.00/month
                </td>
            </tr>
            <tr>
                <td className='time'>4 days/week
                </td>
                <td className='description'>$620.00/month
                </td>
            </tr>
            <tr>
                <td className='time'>5 days/week
                </td>
                <td className='description'>$740.00/month
                </td>
            </tr>
            </tbody>
        </table>
        <p>
            There are 3 ways to pay tuition: Venmo, Bill Pay through your bank, or by check.
        </p>
        <img className="venmo" src="/images/venmo.png"/>
    </div>
);

export default TuitionPage;



// WEBPACK FOOTER //
// ./src/components/TuitionPage.js